import { Link } from "react-router-dom";
import { works } from "@/mocks/works";

const movieCount = works.filter((work) => work.type === "movie").length;
const tvCount = works.filter((work) => work.type === "tv").length;

const entries = [
  {
    to: "/works?type=movie",
    icon: "ri-film-line",
    label: "电影",
    title: "电影作品",
    description: "大银幕上的完整叙事，收录上映年份、类型与详细剧情资料。",
    count: movieCount,
    tone: "primary" as const,
  },
  {
    to: "/works?type=tv",
    icon: "ri-tv-2-line",
    label: "电视剧",
    title: "电视剧作品",
    description: "连续剧与特别篇，按集数与播出信息整理，方便快速检索。",
    count: tvCount,
    tone: "accent" as const,
  },
];

export default function CategoryEntries() {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
      {entries.map((entry) => (
        <Link
          key={entry.to}
          to={entry.to}
          className={[
            "group relative flex items-start gap-5 p-6 md:p-8 rounded-lg border transition-colors cursor-pointer",
            entry.tone === "primary"
              ? "bg-primary-50 border-primary-200 hover:border-primary-400"
              : "bg-accent-50 border-accent-200 hover:border-accent-400",
          ].join(" ")}
        >
          <span
            className={[
              "w-14 h-14 rounded-lg flex items-center justify-center shrink-0",
              entry.tone === "primary"
                ? "bg-primary-500 text-background-50"
                : "bg-accent-500 text-accent-950",
            ].join(" ")}
          >
            <i className={`${entry.icon} text-2xl`}></i>
          </span>
          <span className="flex-1">
            <span
              className={[
                "text-xs font-medium tracking-widest",
                entry.tone === "primary" ? "text-primary-600" : "text-accent-700",
              ].join(" ")}
            >
              {entry.label}
            </span>
            <span className="block mt-1 font-heading text-lg md:text-xl font-semibold text-foreground-950">
              {entry.title}
            </span>
            <span className="block mt-2 text-sm text-foreground-600 leading-relaxed">
              {entry.description}
            </span>
            <span className="inline-flex items-center gap-2 mt-4 text-sm text-foreground-800">
              共 {entry.count} 部作品
              <span className="w-5 h-5 flex items-center justify-center transition-transform group-hover:translate-x-1">
                <i className="ri-arrow-right-line"></i>
              </span>
            </span>
          </span>
        </Link>
      ))}
    </div>
  );
}